import React from 'react';
import styled from 'styled-components';
import AnnouncementBar from '../AnnouncementBar';
import Header from '../Header';
import Footer from '../Footer';
import NewsletterPopup from '../NewsletterPopup';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  position: relative;
  box-sizing: border-box;
  min-width: 0;
`;

const Main = styled.main`
  flex: 1 1 auto;
  min-height: min-content;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  padding-top: calc(var(--header-height) + var(--announcement-height));
  box-sizing: border-box;
  min-width: 0;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <LayoutContainer>
      <AnnouncementBar />
      <Header />
      <Main>{children}</Main>
      <Footer />
      <NewsletterPopup />
    </LayoutContainer>
  );
};

export default Layout;
